import React, { useState, useEffect, useRef, useContext } from 'react';
import { Form, Formik } from 'formik';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Icon from '../Icon';
import Button, { ButtonContainer, ButtonContent } from '../Button';
import {
    Dialog,
    DialogBody,
    DialogText,
    ContentTextArea,
    Header,
    IconsContainer,
    TextArea
} from './styles';

export default function NotesModal({
    title,
    textButtonConfirm,
    textButtonCancel,
    show,
    setModalShow,
    viewMode,
    idOperation,
    idQuestion,
    functionCallback,
    isMediationCompleted,
    textMediation,
    customCancelButton
}){
    const [value, setValue] = useState('');
    const [notes, setNotes] = useState('');
    const [addNote, setAddNote] = useState(false);
    
    const myRef = useRef();
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();

    useEffect(() => {
        handleGetNotes();
    }, [idOperation]);

    const handleUpdateNotes = () => {
        if (idOperation && idQuestion) {
            loading.start();
            fitinsur.setAuthToken(authContext.token);
            fitinsur.requestOperationNotesUpdate(idOperation, idQuestion, value).then(() => {
                loading.stop();
                setAddNote(false);
                setValue('');
                handleGetNotes();
                functionCallback && functionCallback();
            }).catch((error) => {
                loading.stop();
                mc.error("There was an error while fetching your data: \n" + error);
                console.error('fitPostSummary - Error:', error);
            });
        }
    };
    
    const handleGetNotes = () => {
        if (idOperation && idQuestion) {
            loading.start();
            fitinsur.setAuthToken(authContext.token);
            fitinsur.requestOperationNotes(idOperation, idQuestion).then(
                response => response.json()).then(data => {
                setNotes(data.ret_value.notes)
                loading.stop();
            }).catch((error) => {
                loading.stop();
                mc.error("There was an error while fetching your data: \n" + error);
                console.error('fitPostSummary - Error:', error);
            });
        }
    };

    let valueTextArea = '';
    if(isMediationCompleted) {
        valueTextArea = textMediation;
    } else if(addNote) {
        valueTextArea = value;
    } else { 
        valueTextArea = notes;
    }

    return (
        <Dialog canShow={show} >
            <DialogBody ref={myRef}>
                <Header>
                    <DialogText>
                        {title || 'Additional Information'}
                    </DialogText>
                    <IconsContainer>
                        <Icon
                            name='close'
                            className="icon-close"
                            onClick={() => {
                                setModalShow(false);
                                setAddNote(false);
                                setValue('');
                            }}
                        />
                    </IconsContainer>
                </Header>
                {!viewMode && 
                    <IconsContainer style={{margin: '0 0 12px 16px'}}>
                        <Icon
                            name='add-grey'
                            className='icon-add-grey'
                            onClick={() => setAddNote(true)}
                        />
                    </IconsContainer>
                }
                <Formik
                    initialValues={{
                        notes: ''
                    }}
                    onSubmit={() => handleUpdateNotes()}
                >
                    <Form>
                        <ContentTextArea>
                            <TextArea
                                value={valueTextArea}
                                onChange={(e) => setValue(e.target.value)}
                                disabled={!addNote}
                            />
                        </ContentTextArea>
                        {addNote && (
                            <ButtonContainer>
                                <ButtonContent style={{width: '100%'}}>
                                    <Button
                                        type='button'
                                        style={{margin: 0, marginRight: '16px', width: '100%'}}
                                        secondary={!customCancelButton}
                                        custom={customCancelButton}
                                        onClick={() => {
                                            setAddNote(false)
                                            setValue('')
                                        }}
                                    >
                                        {textButtonCancel || 'Cancel'}
                                    </Button>
                                    <Button
                                        type='submit'
                                        style={{margin: 0, marginLeft: '16px', width: '100%'}}
                                        primary
                                    >
                                        {textButtonConfirm || 'Confirm'}
                                    </Button>
                                </ButtonContent>
                            </ButtonContainer>
                        )}                        
                    </Form>
                </Formik>
            </DialogBody>
        </Dialog>
    );
}